import {InfoPage} from '@gongxigames/framework/slot';

export class RubyInfoPage extends InfoPage {
    protected insertHtml(templateString: string, images: Record<string, string>): void {
        super.insertHtml(templateString, images);
        const elements = document.querySelectorAll('.dynamicFontSize');
        const currentLanguage = this.settings.get('lang');

        elements.forEach((element) => {
            if (currentLanguage === 'hu' ||
                currentLanguage === 'el' ||
                currentLanguage === 'ro' ||
                currentLanguage === 'it' ||
                currentLanguage === 'de' ||
                currentLanguage === 'pt' ||
                currentLanguage === 'fi' ||
                currentLanguage === 'bg' ||
                currentLanguage === 'id' ||
                currentLanguage === 'pl') {
                element.classList.add('smaller-text');
            }
        });

        if (this.settings.get('ukRegulations')) {
            (document.querySelector('#rubyCoins .with-uk-regs') as any).style.display = 'block';
            (document.querySelector('#rubyCoins .without-uk-regs') as any).style.display = 'none';
        } else {
            (document.querySelector('#rubyCoins .with-uk-regs') as any).style.display = 'none';
            (document.querySelector('#rubyCoins .without-uk-regs') as any).style.display = 'block';
        }
    }
}
